import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';
import { CacheConstant, CMSPages } from '../../core/constants/app.constant';
import { AppCacheService } from '../../core/services/cache/app-cache.service';
import { CmsService } from '../../core/services/cms.service';

@Injectable({
  providedIn: 'root'
})
export class SalePopUpResolver implements Resolve<any> {

  envProperties = this.cache.get(CacheConstant.Env_Properties);
  buid = this.envProperties.buId;
  cmsPageConfigVO = this.envProperties.cmsPageConfigVO;
  
  constructor(
    private cache: AppCacheService,
    private cmsService: CmsService
  ) { }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    return this.cmsService.getCmsContentByPageNameAndTemplateNum(CMSPages.Home, this.buid, this.cmsPageConfigVO.salePopUpTemplateId).pipe(
      map((response: any) => {
        return !response.hasError ? response : [];
      })
    );
  }
}